import { render, staticRenderFns } from "./login-icon.vue?vue&type=template&id=5460d17d&scoped=true&lang=pug&"
import script from "./login-icon.vue?vue&type=script&lang=js&"
export * from "./login-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460d17d",
  null
  
)

export default component.exports